import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.UWorkRoot),
  () => import('./UWork'),
  (UWork) => {
    ComponentUtil.binder(Hooks.UWorkRoot, UWork);
  },
);
